import { Suspense } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Paper, Stack, useTheme } from '@mui/material'
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner'
import { selectSchoolState, selectSchoolUser } from '../../../redux/schoolSlice'
import MySchoolSidebar from './sidebar'
import { selectActiveOrgId } from '../../../redux/orgSlice'
import { selectUserUid } from '../../../redux/userSlice'
import { tabNames } from '../../../routers/helpers'
import { SCHOOL_LOADING_ERROR_CODES } from '../../../components/LoadingSpinner/loadingErrorCodes'

export enum MENU_ITEMS {
    TEAM = 'Team',
    INVOICES = 'Invoices',
    POLICIES = 'School Policies',
    MY_NOTIFICATIONS = 'My Notifications',
}

// const SETTING_ITEMS = [MENU_ITEMS.MY_NOTIFICATIONS]

const MySchoolLayout = () => {
    const schoolId = useSelector(selectActiveOrgId)
    const schoolAccountState = useSelector(selectSchoolState)
    const schoolUser = useSelector(selectSchoolUser)

    const userId = useSelector(selectUserUid)

    const theme = useTheme()

    if (schoolId === null) {
        return <Navigate to={`/${tabNames.app.index}`} replace />
    }

    if (
        !schoolId ||
        !userId ||
        schoolUser.loading ||
        schoolAccountState === undefined ||
        !schoolUser?.data?.school?.accountState ||
        !schoolUser?.data?.school?.authority
    ) {
        return (
            <LoadingSpinner
                fillViewPortHeight
                fillViewPortWidth
                errorCode={SCHOOL_LOADING_ERROR_CODES.SCHOOL_WORKSPACE.code}
            />
        )
    }

    return (
        <Stack
            id="myschool-layout"
            sx={{
                width: '100vw',
                // height: '100vh',
                minHeight: 1000,
                height: 'var(--viewport-below-app-bar)',
                overflow: 'auto',
                p: 3,
                pb: 0,
                backgroundColor: theme.palette.neutrals[50],
            }}
        >
            <Paper
                elevation={0}
                sx={{
                    borderRadius: '8px 8px 0 0',
                    width: '100%',
                    height: '100%',
                    // flex: 1,
                    p: 3,
                    pb: 0,
                    display: 'flex',
                }}
            >
                <Stack
                    sx={{
                        flex: 1,
                        width: '100%',
                        flexDirection: 'row',
                        gap: 5,
                    }}
                >
                    <MySchoolSidebar />

                    {/* Main Content */}
                    <Stack flex={1}>
                        <Suspense fallback={null}>
                            <Outlet />
                        </Suspense>
                    </Stack>
                </Stack>
            </Paper>
        </Stack>
    )
}

export default MySchoolLayout
